<template>
  <div
    class="rs-settings-row-wide"
  >
    <div class="row-start">
      <span
        v-if="label"
        class="label"
      >{{ label }}</span>
      <div
        v-if="hasSlot"
        class="row-content"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsSettingsRowWide',

  props: {
    label: String,
  },
  computed: {
    hasSlot() {
      const slots = Object.keys(this.$slots);
      return slots.includes('default');
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';

.rs-settings-row-wide{
  display: block;
  align-items: center;
  padding: .75rem 1em;
  width: 100%;
  border-bottom: 1px solid $extra-light-gray;
  transition: background-color 0.2s ease;
  p{
    margin: 0.5rem 0 0 0;
    font-size: 0.875rem;
    color: $dark-gray;
  }
  .label{
    margin: 0;
    width: 19rem;
    font-size: 1rem;
    font-weight: 700;
    flex-shrink: 0;
  }
}
</style>
